import React from 'react'
import type { Artist } from 'types/artist'
import { getTextColor } from '@disco/utils/colors'
import { plural } from '@disco/utils/string-utils'
import ArtistArtwork from 'components/common/artist-artwork'
import Flex from 'components/ui/flex'
import MediaItem from 'components/ui/media-item'
import Skeleton from 'components/ui/skeleton'
import TextOverflow from 'components/ui/text-overflow'
import styles from './index.module.css'

const STAR_ICON = (
  <svg
    className={styles.artistInfoStar}
    fill="currentcolor"
    width="14"
    height="14"
  >
    <polygon points="10.092 11 7 9.235 3.908 11 4.727 7.67 2 5.434 5.596 5.143 7 2 8.403 5.136 12 5.427 9.273 7.663" />
  </svg>
)
type Props = {
  artist: Artist | null | undefined
}

/**
 * Artist information display component with artwork, name, and track count
 * Shows skeleton loading state when artist data is not available
 * @param artist - Artist data to display, null/undefined shows loading state
 */
const ArtistInfo = ({ artist }: Props) => {
  return !artist ? (
    <MediaItem
      media={<ArtistArtwork />}
      title={<Skeleton />}
      caption={<Skeleton />}
    />
  ) : (
    <MediaItem
      media={
        <ArtistArtwork
          color={getTextColor(artist.name)}
          image={artist.image_url}
          imageParams={{
            crop: 'faces',
          }}
        />
      }
      title={artist.name}
      caption={
        <Flex spacing="small">
          {artist.showcase_playlist_exists && STAR_ICON}
          <Flex.Content>
            <TextOverflow
              content={plural(artist.track_count, 'track', 'tracks')}
            />
          </Flex.Content>
        </Flex>
      }
    />
  )
}

export default React.memo<Props>(ArtistInfo)
